import { render, staticRenderFns } from "./exportBaseBase.vue?vue&type=template&id=bf6636b8"
import script from "./exportBaseBase.vue?vue&type=script&lang=js"
export * from "./exportBaseBase.vue?vue&type=script&lang=js"
import style0 from "./exportBaseBase.vue?vue&type=style&index=0&id=bf6636b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports